/**
 * 창이 앞으로 올 때(독·최소화 독·알림으로 열거나 불러올 때) 포커스를 창 틀로 넘긴다.
 * 그러지 않으면 포커스가 독에 남아 창 안까지 Tab 을 독 항목 수만큼 더 눌러야 한다.
 *
 * 이미 어떤 창 안에 포커스가 있으면 no-op — 실시간 이벤트로 열린 창이 채팅 입력 같은
 * 다른 창의 작업을 가로채지 않게 한다. 창 틀은 tabIndex=-1 이라 탭 순서에는 끼지 않는다.
 */
export function claimFocusOnRaise(frame: HTMLElement | null): void {
  if (typeof document === 'undefined' || !frame) return;
  const active = document.activeElement;
  if (active instanceof HTMLElement && active.closest('[data-window-frame]')) return;
  frame.focus({ preventScroll: true });
}
